<script>
import { notificationGetters, notificationActions } from '@state/helpers'
export default {
  data() {
    return {}
  },

  computed: {
    ...notificationGetters,
  },

  methods: {
    ...notificationActions,
    onClickNotificationBell() {
      this.setBellBadge(false)

      // console.log('trying to fetch new notification')
      // this.getNotification()
      // this.isShowBadge = false
    },
  },
}
</script>

<template>
  <b-nav-item-dropdown
    right
    no-caret
    class="notifications d-flex align-items-center mr-2"
  >
    <template slot="button-content">
      <div class="notification-badge" @click="onClickNotificationBell">
        <b-badge
          v-if="isShowBellBadge"
          variant="primary"
          class="custom-badge rounded-circle"
        >
          <span></span>
        </b-badge>
        <BaseIcon size="lg" name="bell" class="custom-icon" />
      </div>
    </template>
    <h4 class="mt-2 px-4">Notifications</h4>
    <hr class="mb-0" />
    <template v-if="notifications.length">
      <b-dropdown-item
        v-for="item in notifications"
        :key="item.id"
        @click.native.capture.stop
      >
        <span>{{ item.message.displayText }}</span>
      </b-dropdown-item>
    </template>
    <template v-else>
      <div class="px-4 py-2">No notifications</div>
    </template>
  </b-nav-item-dropdown>
</template>

<style lang="scss">
.notifications {
  .dropdown-item {
    padding: 12px 24px;
    cursor: auto;
  }

  .notification-badge {
    position: relative;

    .custom-badge {
      position: absolute;
      top: -6px;
      left: 8px;
      padding: 0.1em 0.24em !important;

      span {
        padding: 4px;
      }
    }

    .custom-icon {
      color: #fff !important;
    }
  }
}
</style>
